import { useState } from 'react';
import { MarketPlaceLinksList, MarketPlaceListItem, MarketPlaceLinkItem } from './styles';
import { getMarketplaceListingUrl } from '../../utils/helper';
import { useTranslatedObject } from '../../utils/translation';
import { useSelector } from 'react-redux';
import { FooterNavigationBar, sendGA4Data } from '../../analytics/events';
import { navigateToListingPage } from '@headless-shell/shared-components';

const Solutions = ({ isMobileOrTablet, navigate }) => {
  const [expanded, setExpanded] = useState(false);
  const solution_categories = useTranslatedObject('solution_categories');
  const page = useTranslatedObject('page');
  const solutions_facetType = useTranslatedObject('solutions_facetType');
  const { locale = '' } = useSelector(state => state.app) || {};
  const solutions = Object.keys(solution_categories);
  const visibleCount = isMobileOrTablet ? 5 : solutions.length;
  const visibleItems = expanded ? solutions : solutions.slice(0, visibleCount);

  const onFooterSolutionClick = (solution) => {
    sendGA4Data(FooterNavigationBar, { eventCategory: "Solutions", eventLabel: solution?.label });
  };

  const handleSolutionsClick = (e, solution, url, hasAttributeId) => {
    onFooterSolutionClick(solution);
    e.stopPropagation();
    if (!hasAttributeId) {
      e.preventDefault();
      const listingUrl = navigateToListingPage(url);
      if (listingUrl?.includes('listing')) { 
        navigate(listingUrl);
      }
      navigate(url);
      return;
    }
    // Leave default un-prevented so a real anchor click to href={url} still
    // reloads when we're already on that page (matches marketplace.js).
    navigate(url);
  };

  return (
    <MarketPlaceLinksList id="solution-list">
      {visibleItems.map((key, i) => {
        const solution = solution_categories[key];
        const name = solution.label;
        const hasAttributeId = !!solution.attributeId;
        const url = getMarketplaceListingUrl({
          locale,
          facetType: !hasAttributeId ? solutions_facetType : '',
          solutionName: key,
          attributeId: solution.attributeId,
          apicLabel: solution?.overviewLabel,
          page: hasAttributeId ? (page?.solutions) || 'listing' : 'listing'
        });
        return (
          <MarketPlaceListItem id={`solution-list-item-${i}`} key={i}>
            <MarketPlaceLinkItem
              aria-label={name}
              id={`solution-link-item-${name}`}
              href={url}
              onClick={(e) => handleSolutionsClick(e, solution, url, hasAttributeId)}>
              {name}
            </MarketPlaceLinkItem>
          </MarketPlaceListItem>
        );
      })}

      {isMobileOrTablet && solutions.length > visibleCount && !expanded && (
          <MarketPlaceListItem id="show-more-solutions" key="toggle">
          <MarketPlaceLinkItem
            aria-label={'Show more solutions'}
            id="show-more-solutions"
            onClick={(e) => {
              e.stopPropagation();
              setExpanded(!expanded);
            }}
          >
            Show more
          </MarketPlaceLinkItem>
        </MarketPlaceListItem>
      )}
    </MarketPlaceLinksList>
  );
};

export default Solutions;